export interface DiscordWebhook {
  id: string;
  name: string;
  url: string;
  channel: string;
  server: string;
  active: boolean;
  createdAt: string;
}

export interface DiscordTemplate {
  id: string;
  name: string;
  trigger: string;
  webhookId: string;
  description: string;
  template: string;
  variables: string[];
  active: boolean;
  lastSent: string | null;
  createdAt: string;
}

export const TRIGGER_LABELS: Record<string, string> = {
  gameserver_installed: 'Game Server Installed',
  webadmin_deployed: 'WebAdmin Deployed',
  gameserver_stopped: 'Game Server Stopped',
  backup_completed: 'Backup Completed',
  dev_wp_done: 'Work Package Done',
};
